module.exports = __webpack_public_path__ + "img/save_date.a349cf83.png";